// extracted by mini-css-extract-plugin
module.exports = {"collapsable":"collapsable_collapsable__WRPl_","collapsable_open":"collapsable_collapsable_open__UVpeG"};